import type { IconProps } from './types/types';

const TicketOpenOutlined = (props: IconProps) => {
  const { fill = 'currentColor', ...rest } = props;
  const svgProps = { fill, ...rest };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      {...svgProps}
    >
      <path d="M12.7316 18.502H10.8473C10.788 18.502 10.7299 18.4856 10.6794 18.4545C10.629 18.4235 10.5881 18.379 10.5614 18.3261C10.5348 18.2732 10.5233 18.2139 10.5284 18.1548C10.5335 18.0958 10.5548 18.0393 10.5901 17.9917L17.7419 8.10778C17.7715 8.06671 17.8104 8.03327 17.8555 8.0102C17.9005 7.98713 17.9504 7.9751 18.001 7.9751C18.0517 7.9751 18.1016 7.98713 18.1466 8.0102C18.1917 8.03327 18.2306 8.06671 18.2602 8.10778L25.412 17.9917C25.5647 18.2047 25.412 18.502 25.1508 18.502H23.2664C22.8526 18.502 22.4669 18.3051 22.2258 17.9716L17.999 12.1297L13.7723 17.9716C13.5312 18.3051 13.1414 18.502 12.7316 18.502Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.7863 1.9292H3.21491C2.50375 1.9292 1.9292 2.50375 1.9292 3.21491V32.7863C1.9292 33.4975 2.50375 34.0721 3.21491 34.0721H32.7863C33.4975 34.0721 34.0721 33.4975 34.0721 32.7863V3.21491C34.0721 2.50375 33.4975 1.9292 32.7863 1.9292ZM24 22.019H31.1792V4.82206H4.82206V22.019H12C12.0043 25.3292 14.6889 28.0112 18 28.0112C21.3111 28.0112 23.9958 25.3292 24 22.019Z"
      />
    </svg>
  );
};
export default TicketOpenOutlined;
